export const FeatureFlagConst = {
  FF1182_CODIGO_LYRA_PESSOAS: '1182-codigo-lyra-pessoas',
  FF1183_CODIGO_LYRA_TERRITORIO: '1183-codigo-lyra-territorio'
};
